module.exports = __webpack_public_path__ + "img/gurme.0b6eafca.jpg";